import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'peps-loader',
	templateUrl: './loader.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './loader.component.css'
})
export class LoaderComponent {

	@Input() zIndex: number = 40;

}
